import { FC, useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import { DisableAuthenticationModalProps } from "../../interfaces";
import useStyles from "../Styles/ProjectModalStyles";
import { Formik, Form } from "formik";
import cross from "../../assets/images/cross.svg";
import VerificationInput from "react-verification-input";
import AuthContext from "../../store/Auth/AuthContext";
const DisableAuthenticationModal: FC<DisableAuthenticationModalProps> = ({
  open,
  setOpen,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { disable2FA } = useContext<any>(AuthContext);
  const [codeValue, setcodeValue] = useState("");
  const [error, setError] = useState(false);

  function setcodeValues(val: any) {
    if (val.length === 6) {
      setcodeValue(val);
    } else {
      setError(false);
    }
  }

  const handleClose = () => {
    setOpen(false);
    setError(false);
  };

  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            mt={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 3}
            mb={isActive ? "20px" : 4}
          >
            <Box className="relative-box">
              {!isActive && (
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  onClick={handleClose}
                />
              )}
              <ProjectPoolHeading
                title1="Two factor  "
                title2="Authentication"
              />
              <Box>
                <Typography variant="h3" className="fw-bold ">
                  Disable 2FA
                </Typography>
              </Box>

              <Box mt={2}>
                <Typography
                  variant="subtitle1"
                  className="fw-normal "
                  color="secondary"
                >
                  Enter Code to diable 2FA Authentication
                </Typography>
              </Box>
              <Box mt={1}>
                <Formik
                  initialValues={{}}
                  onSubmit={(values) => {
                    if (codeValue.length === 6) {
                      disable2FA(codeValue);
                      setOpen(false);
                      setError(false);
                    } else {
                      setError(true);
                    }
                  }}
                >
                  <Form>
                    <Box mt={isActive ? 2 : 2} className="pt-0">
                      <Grid container alignItems="center" spacing={0}>
                        <Grid item lg={7} md={7} sm={6} xs={12}>
                          <Box mb={isActive ? 1 : 0}>
                            <VerificationInput
                              removeDefaultStyles
                              placeholder=""
                              autoFocus={true}
                              validChars="0-9"
                              onChange={(e) => setcodeValues(e)}
                              classNames={{
                                character: "character",
                              }}
                            />
                          </Box>
                          {error && (
                            <Typography
                              variant="subtitle1"
                              className="error mt-12"
                            >
                              Please enter 6 digits code
                            </Typography>
                          )}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box
                            display="flex"
                            mt={5}
                            justifyContent={isActive ? "space-between" : ""}
                          >
                            <Box mr={2}>
                              <Button
                                variant="contained"
                                className="button-buy"
                                color="secondary"
                                type="submit"
                              >
                                Confirm
                              </Button>
                            </Box>
                            <Box>
                              <Button
                                className="button-buy"
                                variant="outlined"
                                color="secondary"
                                onClick={handleClose}
                              >
                                Cancel
                              </Button>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                </Formik>
              </Box>

              <Box mt={isActive ? 3 : 3}></Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default DisableAuthenticationModal;
